<template>
  <TableLayout :permissions="['business:shopInfo:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="门店名称" prop="name">
        <el-input v-model="searchForm.name" clearable placeholder="请输入门店名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="companyType">
        <el-select v-model="searchForm.companyType" clearable placeholder="请选择类型" @change="search">
          <el-option label="企业" :value="1"></el-option>
          <el-option label="个人" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="门店地址" prop="address">
        <el-input v-model="searchForm.address" clearable placeholder="请输入门店地址" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="linkName">
        <el-input v-model="searchForm.linkName" clearable placeholder="请输入联系人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="linkPhone">
        <el-input v-model="searchForm.linkPhone" clearable placeholder="请输入联系电话" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="linkPhone">
        <el-input v-model="searchForm.linkPhone" clearable placeholder="请输入联系电话" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="注册时间" prop="createTimeStr">
        <el-date-picker type="daterange" v-model="searchForm.createTimeStr" clearable value-format="yyyy-MM-dd"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange" />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="searchForm.status" clearable placeholder="请选择状态" @change="search">
          <el-option label="启用" :value="0"></el-option>
          <el-option label="禁用" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <template v-slot:table-wrap>
      <el-table
          :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="门店名称" min-width="120px">
          <template slot-scope="{row}">
            <span class="link-name" @click="openShopInfo(row)">{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyType" label="类型" min-width="80px">
          <template slot-scope="{row}">
            {{row.companyType == 1 ? '企业' : '个人'}}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="门店地址" min-width="200px"></el-table-column>
        <el-table-column prop="linkName" label="联系人" min-width="100px"></el-table-column>
        <el-table-column prop="linkPhone" label="联系电话" min-width="120px"></el-table-column>
        <el-table-column prop="printerSn" label="打印机序列号" min-width="160px">
          <template slot-scope="{row}">
            <span class="greenstate"  style="cursor: pointer"   @click="$refs.operaPrinterEditWindow.open('门店打印机设置', row)" v-if="row.printerSn"  >{{ row.printerSn }}</span>
            <span class="redstate" style="cursor: pointer" v-else  @click="$refs.operaPrinterEditWindow.open('门店打印机设置', row)"> 未设置</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册日期" min-width="160px"></el-table-column>
        <el-table-column label="账号状态" min-width="100px">
          <template slot-scope="{row}">
            <el-switch @change="changeStatus($event, row)" v-model="row.status" active-color="#13ce66"
            inactive-color="#ff4949" :active-value="0" :inactive-value="1">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="180" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" @click="$refs.operaPrinterEditWindow.open('门店打印机设置', row)">打印机设置</el-button>
            <el-button type="text" @click="handleResetPwd(row)">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 门店详情 -->
    <OperaShopInfoWindow ref="operaShopInfoWindow" />
    <!-- 编辑门店 -->
    <OperaPrinterEditWindow ref="operaPrinterEditWindow" @success="search" />
    <OperaShopEditWindow ref="operaShopEditWindow" @success="search" />
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaShopInfoWindow from '@/components/business/OperaShopInfoWindow'
import OperaShopEditWindow from '@/components/business/OperaShopEditWindow'
import OperaPrinterEditWindow from '@/components/business/OperaPrinterEditWindow'
import { changeStatus, resetPassword } from '@/api/business/shopInfo'
export default {
  name: 'StoreList',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaShopInfoWindow, OperaShopEditWindow,OperaPrinterEditWindow },
  data () {
    return {
      searchForm: {
        name: '',
        companyType: '',
        address: '',
        linkName: '',
        linkPhone: '',
        createTimeStr: '',
        createStartTime: '',
        auditStatus: 3,
        status: '',
        createEndTime: ''
      }
    }
  },
  created () {
    this.config({
      module: '门店列表',
      api: '/business/shopInfo',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    handleDateChange (val) {
      this.searchForm.createStartTime = val ? val[0] : ''
      this.searchForm.createEndTime = val ? val[1] : ''
    },
    changeStatus (e, row) {
      this.working = true
      changeStatus({ id: row.id, status: e })
        .then(res => {
          this.$tip.apiSuccess(res || '操作成功')
          this.search()
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.working = false
        })
    },
    openShopInfo (row) {
      this.$refs.operaShopInfoWindow.open('门店信息', row)
    },
    handleEdit (row) {
      this.$refs.operaShopEditWindow.open('编辑门店', row)
    },
    handleResetPwd (row) {
      this.$confirm('是否确认重置门店密码？', '提示')
        .then(() => {
          resetPassword({ id: row.id })
            .then(res => {
              this.$tip.apiSuccess(res || '重置密码成功')
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.link-name {
  color: #2E68EC;
  text-decoration: underline;
  cursor: pointer;
}
</style>
